import SEO from '../../components/base/SEO';
import { useState } from 'react';

export default function HomePage() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      text: "Necesitábamos vaciar el piso de mi madre en L'Hospitalet tras su fallecimiento. El equipo de Marius fue increíblemente respetuoso y eficiente. Nos ayudaron a identificar qué muebles tenían valor y el vaciado nos salió gratis. Muy recomendable.",
      author: "Carmen R.",
      location: "L'Hospitalet de Llobregat",
      initials: "CR",
      rating: "4.9/5"
    },
    {
      text: "Teníamos que vaciar un piso de 90m² en Barcelona centro en menos de una semana para una reforma urgente. Vinieron al día siguiente de llamar, protegieron todo el edificio y lo dejaron impecable. Profesionales de verdad.",
      author: "Jordi M.",
      location: "Barcelona Centro",
      initials: "JM",
      rating: "5/5"
    },
    {
      text: "Compraron varios muebles antiguos de mi abuela que tenían más de 100 años. Me explicaron el valor de cada pieza con total transparencia y el resto del vaciado fue gratuito. Excelente trato y muy honestos.",
      author: "Ana S.",
      location: "Sant Cugat del Vallès",
      initials: "AS",
      rating: "4.8/5"
    }
  ];

  const handlePrevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "VACIADOS MARIUS",
    "image": "https://public.readdy.ai/ai/img_res/6bea04c8-eed4-4f8d-a07d-4399896150a0.png",
    "@id": `${import.meta.env.VITE_SITE_URL || 'https://vaciado-pisos-barcelona.vaciadosmarius.com.es'}/#organization`,
    "url": import.meta.env.VITE_SITE_URL || "https://vaciado-pisos-barcelona.vaciadosmarius.com.es/",
    "telephone": "+34936940041",
    "email": "vaciadosmarius@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Barcelona",
      "addressRegion": "Cataluña",
      "addressCountry": "ES"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "41.3851",
      "longitude": "2.1734"
    },
    "areaServed": [
      "Barcelona", "L'Hospitalet de Llobregat", "Badalona", "Santa Coloma de Gramenet",
      "Cornellà de Llobregat", "El Prat de Llobregat", "Sant Boi de Llobregat",
      "Castelldefels", "Gavà", "Viladecans", "Esplugues de Llobregat",
      "Sant Just Desvern", "Sant Joan Despí", "Sant Cugat del Vallès",
      "Cerdanyola del Vallès", "Montcada i Reixac", "Mataró", "Sabadell", "Terrassa"
    ],
    "priceRange": "€€",
    "sameAs": "https://share.google/FizsQeezE7RkuyEkt"
  };

  const servicesSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Vaciado completo de pisos",
        "description": "Vaciado integral de viviendas incluyendo muebles, enseres, desmontaje y gestión de residuos"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Recogida selectiva de muebles",
        "description": "Retirada de muebles y objetos específicos sin vaciado completo"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Vaciado por herencia",
        "description": "Servicio especializado en vaciado de pisos tras fallecimientos con máxima discreción"
      },
      {
        "@type": "ListItem",
        "position": 4,
        "name": "Vaciado para reformas",
        "description": "Vaciado rápido de viviendas para inicio de obras o fin de contrato"
      },
      {
        "@type": "ListItem",
        "position": 5,
        "name": "Compra de muebles de diseño y antigüedades",
        "description": "Compra de muebles de diseño firmados y antigüedades de más de 100 años"
      },
      {
        "@type": "ListItem",
        "position": 6,
        "name": "Limpieza final opcional",
        "description": "Limpieza profunda tras el vaciado para entrega de llaves"
      }
    ]
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Inicio",
        "item": import.meta.env.VITE_SITE_URL || "https://vaciado-pisos-barcelona.vaciadosmarius.com.es/"
      }
    ]
  };

  return (
    <>
      <SEO
        title="Vaciado de Pisos en Barcelona | Rápido y Sin Complicaciones | VACIADOS MARIUS"
        description="Vaciado completo de pisos en Barcelona y provincia. Evaluación gratuita, compra de muebles antiguos y de diseño. Llamar 936 94 00 41 o WhatsApp 633 759 649."
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://vaciado-pisos-barcelona.vaciadosmarius.com.es'}/`}
        keywords="vaciado de pisos en Barcelona, vaciar piso Barcelona, recogida de muebles Barcelona, vaciado de viviendas, vaciado por herencia, vaciado por reforma"
        geoRegion="ES-CT"
        geoPlacename="Barcelona"
        geoPosition="41.3851;2.1734"
        jsonLd={[localBusinessSchema, servicesSchema, breadcrumbSchema]}
      />

      <main className="pt-0 overflow-x-hidden">
        {/* Hero Section */}
        <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/e0665095799a39ca23b527a99ebe78f2.jpg"
              alt="Vaciado profesional de pisos en Barcelona"
              className="w-full h-full object-cover object-top"
              loading="eager"
              fetchpriority="high"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
          </div>

          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 text-center">
            <h1 className="text-3xl sm:text-5xl md:text-7xl font-serif font-bold text-white mb-4 sm:mb-6 uppercase tracking-wide leading-tight">
              VACIADO DE PISOS EN BARCELONA
            </h1>
            <p className="text-base sm:text-xl md:text-2xl text-white/90 mb-6 sm:mb-8 font-light px-2 sm:px-4 leading-relaxed">
              Rápido, discreto y sin complicaciones<br />
              Evaluación gratuita en 24-48h
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 mb-8 sm:mb-12 px-2 sm:px-4">
              <a
                href="tel:+34936940041"
                className="flex items-center space-x-2 px-5 sm:px-8 py-2.5 sm:py-4 bg-black text-white rounded-full text-xs sm:text-base font-medium hover:bg-gray-900 transition-all hover:scale-105 whitespace-nowrap cursor-pointer w-full sm:w-auto justify-center"
              >
                <div className="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center bg-orange-500 rounded-full flex-shrink-0">
                  <i className="ri-phone-fill text-white text-xs sm:text-base"></i>
                </div>
                <span className="text-xs sm:text-base">LLAMAR 936 94 00 41</span>
              </a>
              <a
                href="https://wa.me/34633759649"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 px-5 sm:px-8 py-2.5 sm:py-4 bg-green-600 text-white rounded-full text-xs sm:text-base font-medium hover:bg-green-700 transition-all hover:scale-105 whitespace-nowrap cursor-pointer w-full sm:w-auto justify-center"
              >
                <i className="ri-whatsapp-fill text-base sm:text-xl flex-shrink-0"></i>
                <span className="text-xs sm:text-base">WHATSAPP 633 759 649</span>
              </a>
              <a
                href="https://wa.me/34633759649"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 px-5 sm:px-8 py-2.5 sm:py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white rounded-full text-xs sm:text-base font-medium hover:bg-white/20 transition-all hover:scale-105 whitespace-nowrap cursor-pointer w-full sm:w-auto justify-center"
              >
                <i className="ri-image-line text-base sm:text-xl flex-shrink-0"></i>
                <span className="text-xs sm:text-base">ENVIAR FOTOS</span>
              </a>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6 text-xs text-white/90 px-2 sm:px-4">
              <div className="flex items-center space-x-1.5 sm:space-x-2">
                <i className="ri-shield-check-line text-teal-400 flex-shrink-0 text-sm sm:text-base"></i>
                <span>Discreción garantizada</span>
              </div>
              <div className="flex items-center space-x-1.5 sm:space-x-2">
                <i className="ri-shield-check-line text-teal-400 flex-shrink-0 text-sm sm:text-base"></i>
                <span>Protección de zonas comunes</span>
              </div>
              <div className="flex items-center space-x-1.5 sm:space-x-2">
                <i className="ri-shield-check-line text-teal-400 flex-shrink-0 text-sm sm:text-base"></i>
                <span>+15 años experiencia</span>
              </div>
              <div className="flex items-center space-x-1.5 sm:space-x-2">
                <i className="ri-shield-check-line text-teal-400 flex-shrink-0 text-sm sm:text-base"></i>
                <span className="break-words">Cobertura Barcelona y provincia</span>
              </div>
            </div>
          </div>
        </section>

        {/* Trust Signal Bar */}
        <section className="bg-gray-50 py-12 sm:py-16 overflow-hidden">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="text-center text-sm font-serif text-gray-600 mb-8">
              Más de 500 familias confían en nosotros
            </p>
            <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-lg p-6 sm:p-8 relative">
              <div className="absolute top-4 sm:top-6 left-4 sm:left-6 px-3 py-1 bg-orange-500 text-white rounded-full text-xs font-semibold flex items-center space-x-1">
                <i className="ri-star-fill"></i>
                <span>{testimonials[currentTestimonial].rating}</span>
              </div>
              <blockquote className="text-base sm:text-lg font-serif text-gray-800 italic mt-8 mb-6">
                "{testimonials[currentTestimonial].text}"
              </blockquote>
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-teal-700 font-semibold">{testimonials[currentTestimonial].initials}</span>
                </div>
                <div>
                  <p className="font-semibold text-gray-900">{testimonials[currentTestimonial].author}</p>
                  <p className="text-sm text-gray-600">{testimonials[currentTestimonial].location}</p>
                </div>
              </div>
              <div className="absolute bottom-4 sm:bottom-6 right-4 sm:right-6 flex items-center space-x-2">
                <button 
                  onClick={handlePrevTestimonial}
                  className="w-10 h-10 flex items-center justify-center border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-left-s-line text-gray-600"></i>
                </button>
                <button 
                  onClick={handleNextTestimonial}
                  className="w-10 h-10 flex items-center justify-center bg-black text-white rounded-lg hover:bg-gray-900 transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-s-line"></i>
                </button>
              </div>
            </div>
            <div className="text-center mt-6">
              <a href="/empresa" className="text-teal-600 hover:text-teal-700 font-semibold text-sm cursor-pointer">
                Conoce más sobre nuestra empresa y valores →
              </a>
            </div>
          </div>
        </section>

        {/* Cuándo es Gratis Section */}
        <section className="bg-gradient-to-b from-amber-900 to-amber-950 py-16 sm:py-20 overflow-hidden">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="mb-6">
              <span className="inline-block px-4 py-1 bg-purple-400/20 text-purple-200 rounded-full text-xs font-semibold uppercase tracking-wide">
                IMPORTANTE
              </span>
            </div>
            <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center">
              <div>
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-white mb-6 leading-tight">
                  ¿Cuándo es gratis el vaciado de tu piso?
                </h2>
                <p className="text-base sm:text-lg text-white/90 mb-8 leading-relaxed">
                  El <a href="https://vaciadosmarius.com.es/" target="_blank" rel="noopener noreferrer" className="text-teal-400 hover:text-teal-300 underline cursor-pointer">vaciado puede ser sin coste</a> si los muebles, electrodomésticos u objetos tienen valor suficiente para compensar el trabajo. Evaluamos cada caso individualmente.
                </p>
                <div className="space-y-4 mb-8">
                  <div className="flex items-start space-x-3">
                    <div className="w-6 h-6 flex items-center justify-center bg-teal-500 rounded-full flex-shrink-0 mt-1">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-white/90">Evaluación personalizada</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-6 h-6 flex items-center justify-center bg-teal-500 rounded-full flex-shrink-0 mt-1">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-white/90">Cada piso es diferente</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-6 h-6 flex items-center justify-center bg-teal-500 rounded-full flex-shrink-0 mt-1">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-white/90">Te explicamos el criterio con transparencia</p>
                  </div>
                </div>
                <div className="flex flex-wrap gap-3">
                  <a
                    href="https://wa.me/34633759649"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block px-6 sm:px-8 py-3 sm:py-4 bg-white text-gray-900 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base"
                  >
                    SOLICITAR EVALUACIÓN
                  </a>
                  <a
                    href="/faq"
                    className="inline-block px-6 sm:px-8 py-3 sm:py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white rounded-full font-semibold hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base"
                  >
                    VER PREGUNTAS FRECUENTES
                  </a>
                </div>
              </div>
              <div className="relative">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20appraiser%20examining%20antique%20wooden%20furniture%20in%20Barcelona%20apartment%2C%20team%20member%20with%20clipboard%20inspecting%20vintage%20dresser%20details%2C%20close-up%20of%20hands%20checking%20furniture%20quality%20and%20craftsmanship%2C%20warm%20indoor%20lighting%2C%20professional%20evaluation%20process%2C%20detailed%20furniture%20assessment%20scene%20with%20measuring%20tape%20and%20notes&width=800&height=900&seq=evaluation-001&orientation=portrait"
                  alt="Evaluación de muebles"
                  className="w-full h-[400px] sm:h-[500px] object-cover object-top rounded-2xl shadow-2xl"
                  loading="lazy"
                  decoding="async"
                />
                <div className="absolute bottom-6 sm:bottom-8 left-6 sm:left-8 bg-white/95 backdrop-blur-sm rounded-xl p-4 sm:p-6 shadow-xl max-w-[calc(100%-3rem)]">
                  <p className="text-4xl sm:text-6xl font-serif font-bold text-gray-900 mb-2">100%</p>
                  <p className="text-xs sm:text-sm text-gray-700 leading-relaxed">
                    Evaluación personalizada<br />
                    Cada piso es diferente<br />
                    Criterio transparente
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Compra de Muebles Section */}
        <section className="bg-white py-16 sm:py-20 overflow-hidden">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col lg:flex-row justify-between items-start mb-12">
              <div>
                <h2 className="text-4xl sm:text-5xl font-light text-gray-400 mb-2">Compramos</h2>
                <p className="text-3xl sm:text-4xl font-serif italic text-gray-900">muebles con historia</p>
              </div>
              <p className="text-gray-700 max-w-2xl mt-6 lg:mt-0 leading-relaxed text-sm sm:text-base">
                No todos los muebles tienen valor de reventa. Compramos únicamente <a href="/servicios#compra-muebles" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">muebles de diseño reconocido o antigüedades</a> de más de 100 años. Si tienes dudas, envíanos fotos por WhatsApp antes de tirar nada.
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-4 sm:gap-6">
              <div className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all cursor-pointer">
                <img
                  src="https://readdy.ai/api/search-image?query=Iconic%20mid-century%20modern%20Eames%20lounge%20chair%20in%20pristine%20condition%2C%20classic%20designer%20furniture%20piece%20with%20leather%20upholstery%20and%20wooden%20frame%2C%20studio%20photography%20with%20clean%20white%20background%2C%20professional%20product%20shot%20highlighting%20craftsmanship%20and%20design%20details%2C%20vintage%20furniture%20collectible&width=600&height=700&seq=design-chair-001&orientation=portrait"
                  alt="Muebles de diseño"
                  className="w-full h-80 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  decoding="async"
                />
                <div className="absolute top-4 left-4 px-3 py-1 bg-lime-400 text-gray-900 rounded-full text-xs font-bold uppercase">
                  DISEÑO
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                  <h3 className="text-white font-bold text-lg">
                    Muebles de diseño firmados (Eames, Thonet, etc.)
                  </h3>
                </div>
              </div>

              <div className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all bg-gray-900 flex items-center justify-center cursor-pointer">
                <div className="text-center p-8">
                  <div className="w-32 h-32 mx-auto mb-6 flex items-center justify-center">
                    <i className="ri-ancient-gate-line text-lime-400 text-8xl"></i>
                  </div>
                  <div className="px-3 py-1 bg-lime-400 text-gray-900 rounded-full text-xs font-bold uppercase inline-block mb-4">
                    ANTIGÜEDADES
                  </div>
                  <h3 className="text-white font-bold text-lg">
                    Muebles de más de 100 años con valor histórico
                  </h3>
                </div>
              </div>

              <div className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all cursor-pointer">
                <img
                  src="https://readdy.ai/api/search-image?query=Ornate%20vintage%20wooden%20dresser%20with%20intricate%20carvings%20and%20brass%20handles%2C%20antique%20furniture%20piece%20over%20100%20years%20old%2C%20detailed%20craftsmanship%20with%20decorative%20elements%2C%20warm%20indoor%20lighting%20highlighting%20wood%20grain%20and%20patina%2C%20classic%20European%20antique%20furniture%20style%2C%20professional%20furniture%20photography&width=600&height=700&seq=antique-dresser-001&orientation=portrait"
                  alt="Valoración de antigüedades"
                  className="w-full h-80 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  decoding="async"
                />
                <div className="absolute top-4 left-4 px-3 py-1 bg-lime-400 text-gray-900 rounded-full text-xs font-bold uppercase">
                  VALORACIÓN
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                  <h3 className="text-white font-bold text-lg">
                    Envíanos fotos, marca, medidas y estado
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Servicios Principales */}
        <section className="bg-gray-50 py-16 sm:py-20 overflow-hidden">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-12 sm:mb-16 px-4">
              <span className="text-gray-900">Nuestros servicios de </span>
              <span className="text-teal-600">vaciado en Barcelona</span>
            </h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-8">
              <a href="/servicios#vaciado-completo" className="lg:row-span-2 group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all cursor-pointer">
                <img
                  src="https://readdy.ai/api/search-image?query=Complete%20apartment%20clearance%20in%20progress%2C%20empty%20Barcelona%20flat%20with%20professional%20movers%20loading%20furniture%20onto%20truck%2C%20bright%20spacious%20interior%20being%20cleared%20systematically%2C%20organized%20moving%20process%20with%20wrapped%20furniture%20and%20boxes%2C%20efficient%20team%20working%20in%20modern%20apartment%2C%20professional%20clearance%20service&width=700&height=900&seq=complete-clearance-001&orientation=portrait"
                  alt="Vaciado completo de pisos"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  decoding="async"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent p-8">
                  <h3 className="text-white font-bold text-2xl mb-2">Vaciado completo de pisos</h3>
                  <p className="text-white/80 text-sm">Servicio integral incluyendo desmontaje y gestión de residuos</p>
                </div>
              </a>

              <a href="/servicios#recogida-muebles" className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all bg-emerald-100 flex items-center justify-center p-8 cursor-pointer">
                <div className="text-center">
                  <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center bg-emerald-600 rounded-full">
                    <i className="ri-truck-line text-white text-3xl"></i>
                  </div>
                  <h3 className="text-gray-900 font-bold text-xl">Recogida selectiva de muebles</h3>
                </div>
              </a>

              <a href="/servicios#herencias" className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all bg-rose-100 flex items-center justify-center p-8 cursor-pointer">
                <div className="text-center">
                  <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center bg-rose-600 rounded-full">
                    <i className="ri-heart-line text-white text-3xl"></i>
                  </div>
                  <h3 className="text-gray-900 font-bold text-xl">Vaciados por herencia o reforma</h3>
                </div>
              </a>
            </div>

            <div className="text-center">
              <a
                href="/servicios"
                className="inline-flex items-center space-x-2 text-teal-600 font-semibold hover:text-teal-700 transition-colors cursor-pointer"
              >
                <span>Ver todos los servicios</span>
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </section>

        {/* Proceso en 4 Pasos */}
        <section className="bg-white py-16 sm:py-20 overflow-hidden">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center text-gray-900 mb-12 sm:mb-16">
              Cómo trabajamos: proceso transparente
            </h2>

            <div className="space-y-16 sm:space-y-24">
              {/* Step 1 */}
              <div className="grid lg:grid-cols-2 gap-12 items-center">
                <div>
                  <div className="text-7xl font-bold text-teal-500/20 mb-4">01</div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-4">Evaluación inicial</h3>
                  <p className="text-gray-700 leading-relaxed mb-6">
                    Envíanos fotos y vídeos por WhatsApp o programa una visita presencial gratuita. Evaluamos el contenido del piso, identificamos objetos de valor y te damos una primera valoración en 24-48 horas.
                  </p>
                  <div className="flex items-center space-x-4 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full">
                      <i className="ri-whatsapp-fill text-teal-600 text-xl"></i>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">Envía fotos por WhatsApp</p>
                      <p className="font-semibold text-gray-900">633 759 649</p>
                    </div>
                  </div>
                  <a href="/empresa#como-trabajamos" className="text-teal-600 hover:text-teal-700 font-semibold text-sm cursor-pointer">
                    Conoce nuestro método de trabajo completo →
                  </a>
                </div>
                <div>
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20team%20member%20on%20phone%20call%20reviewing%20apartment%20photos%20on%20tablet%2C%20friendly%20service%20representative%20in%20uniform%20taking%20notes%20during%20client%20consultation%2C%20modern%20office%20setting%20with%20Barcelona%20cityscape%20visible%20through%20window%2C%20customer%20service%20and%20evaluation%20process%2C%20professional%20communication&width=800&height=600&seq=evaluation-call-001&orientation=landscape"
                    alt="Evaluación inicial"
                    className="w-full h-80 object-cover object-top rounded-2xl shadow-lg"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </div>

              {/* Step 2 */}
              <div className="grid lg:grid-cols-2 gap-12 items-center">
                <div className="order-2 lg:order-1">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20document%20and%20tablet%20showing%20detailed%20clearance%20proposal%20and%20budget%2C%20hands%20pointing%20at%20itemized%20cost%20breakdown%20on%20screen%2C%20transparent%20pricing%20document%20with%20clear%20sections%2C%20modern%20business%20presentation%2C%20professional%20service%20quotation%20with%20calculator%20and%20pen&width=800&height=600&seq=proposal-document-001&orientation=landscape"
                    alt="Propuesta personalizada"
                    className="w-full h-80 object-cover object-top rounded-2xl shadow-lg"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="order-1 lg:order-2">
                  <div className="text-7xl font-bold text-teal-500/20 mb-4">02</div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-4">Propuesta personalizada</h3>
                  <p className="text-gray-700 leading-relaxed mb-6">
                    Te presentamos una propuesta clara: vaciado gratuito si el valor compensa, presupuesto ajustado si hay coste, o compra de muebles específicos. Sin sorpresas, todo transparente desde el inicio.
                  </p>
                  <div className="space-y-3">
                    <div className="flex items-center space-x-3">
                      <i className="ri-checkbox-circle-fill text-teal-600 text-xl"></i>
                      <span className="text-gray-700">Presupuesto sin compromiso</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <i className="ri-checkbox-circle-fill text-teal-600 text-xl"></i>
                      <span className="text-gray-700">Opciones claras y detalladas</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Step 3 */}
              <div className="grid lg:grid-cols-2 gap-12 items-center">
                <div>
                  <div className="text-7xl font-bold text-teal-500/20 mb-4">03</div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-4">Vaciado profesional</h3>
                  <p className="text-gray-700 leading-relaxed mb-6">
                    Nuestro equipo protege escaleras, ascensor y zonas comunes. Desmontamos lo necesario, cargamos con cuidado y gestionamos los residuos según normativa. Todo coordinado y eficiente.
                  </p>
                  <div className="space-y-3">
                    <div className="flex items-center space-x-3">
                      <i className="ri-shield-check-line text-teal-600 text-xl"></i>
                      <span className="text-gray-700">Protección total de espacios</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <i className="ri-team-line text-teal-600 text-xl"></i>
                      <span className="text-gray-700">Equipo experimentado</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <i className="ri-recycle-line text-teal-600 text-xl"></i>
                      <span className="text-gray-700">Gestión responsable</span>
                    </div>
                  </div>
                </div>
                <div>
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20movers%20loading%20wrapped%20furniture%20into%20large%20moving%20truck%2C%20team%20working%20efficiently%20with%20protected%20items%20and%20organized%20boxes%2C%20Barcelona%20street%20scene%20with%20moving%20van%2C%20workers%20in%20uniform%20carrying%20furniture%20down%20building%20stairs%20with%20protective%20padding%2C%20professional%20logistics%20operation&width=800&height=600&seq=loading-truck-001&orientation=landscape"
                    alt="Vaciado profesional"
                    className="w-full h-80 object-cover object-top rounded-2xl shadow-lg"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </div>

              {/* Step 4 */}
              <div className="grid lg:grid-cols-2 gap-12 items-center">
                <div className="order-2 lg:order-1">
                  <img
                    src="https://readdy.ai/api/search-image?query=Completely%20empty%20and%20clean%20Barcelona%20apartment%20ready%20for%20handover%2C%20spotless%20bright%20interior%20with%20shiny%20floors%20and%20clean%20walls%2C%20sunlight%20streaming%20through%20windows%20into%20vacant%20rooms%2C%20pristine%20condition%20after%20professional%20clearance%20and%20cleaning%2C%20ready%20for%20new%20tenant%20or%20sale&width=800&height=600&seq=empty-clean-apartment-001&orientation=landscape"
                    alt="Revisión final"
                    className="w-full h-80 object-cover object-top rounded-2xl shadow-lg"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="order-1 lg:order-2">
                  <div className="text-7xl font-bold text-teal-500/20 mb-4">04</div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-4">Revisión final y limpieza</h3>
                  <p className="text-gray-700 leading-relaxed mb-6">
                    Hacemos una revisión contigo para asegurar que todo está correcto. Si necesitas limpieza final para entrega de llaves, venta o alquiler, te ofrecemos este servicio adicional.
                  </p>
                  <a
                    href="/servicios#limpieza"
                    className="inline-flex items-center space-x-2 text-teal-600 font-semibold hover:text-teal-700 transition-colors cursor-pointer"
                  >
                    <span>Más sobre limpieza final</span>
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Cobertura Geográfica */}
        <section id="cobertura" className="bg-gray-50 py-16 sm:py-20 overflow-hidden">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 px-4">
                Vaciado de pisos en toda Barcelona y área metropolitana
              </h2>
              <p className="text-base sm:text-lg text-gray-700 max-w-3xl mx-auto px-4">
                Ofrecemos nuestros servicios profesionales de <a href="https://es.wikipedia.org/wiki/Barcelona" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:text-teal-700 underline cursor-pointer">vaciado en Barcelona ciudad</a> y toda la provincia
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-12">
              {[
                { name: 'Barcelona ciudad', icon: 'ri-building-line' },
                { name: 'L\'Hospitalet de Llobregat', icon: 'ri-map-pin-line' },
                { name: 'Badalona', icon: 'ri-map-pin-line' },
                { name: 'Santa Coloma de Gramenet', icon: 'ri-map-pin-line' },
                { name: 'Cornellà de Llobregat', icon: 'ri-map-pin-line' },
                { name: 'El Prat de Llobregat', icon: 'ri-map-pin-line' },
                { name: 'Sant Boi de Llobregat', icon: 'ri-map-pin-line' },
                { name: 'Castelldefels', icon: 'ri-map-pin-line' },
                { name: 'Gavà', icon: 'ri-map-pin-line' },
                { name: 'Viladecans', icon: 'ri-map-pin-line' },
                { name: 'Esplugues de Llobregat', icon: 'ri-map-pin-line' },
                { name: 'Sant Just Desvern', icon: 'ri-map-pin-line' },
                { name: 'Sant Joan Despí', icon: 'ri-map-pin-line' },
                { name: 'Sant Cugat del Vallès', icon: 'ri-map-pin-line' },
                { name: 'Cerdanyola del Vallès', icon: 'ri-map-pin-line' },
                { name: 'Montcada i Reixac', icon: 'ri-map-pin-line' },
                { name: 'Mataró', icon: 'ri-map-pin-line' },
                { name: 'Sabadell', icon: 'ri-map-pin-line' },
                { name: 'Terrassa', icon: 'ri-map-pin-line' },
                { name: 'Mollet del Vallès', icon: 'ri-map-pin-line' }
              ].map((location, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg p-3 sm:p-4 hover:shadow-md transition-shadow flex items-center space-x-3"
                >
                  <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                    <i className={`${location.icon} text-teal-600 text-base sm:text-lg`}></i>
                  </div>
                  <span className="text-gray-900 font-medium text-xs sm:text-sm break-words">{location.name}</span>
                </div>
              ))}
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
                <i className="ri-map-2-line text-teal-600 text-3xl"></i>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3">
                ¿Tu municipio no aparece en la lista?
              </h3>
              <p className="text-sm sm:text-base text-gray-700 mb-6 max-w-2xl mx-auto">
                También trabajamos en otros municipios de la provincia de Barcelona. Consúltanos tu ubicación y te confirmamos disponibilidad.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
                <a
                  href="tel:+34936940041"
                  className="flex items-center space-x-2 px-5 sm:px-6 py-3 bg-teal-600 text-white rounded-full font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base w-full sm:w-auto justify-center"
                >
                  <i className="ri-phone-fill text-base sm:text-lg flex-shrink-0"></i>
                  <span>CONSULTAR ZONA</span>
                </a>
                <a
                  href="https://wa.me/34633759649"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 px-5 sm:px-6 py-3 bg-green-600 text-white rounded-full font-semibold hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base w-full sm:w-auto justify-center"
                >
                  <i className="ri-whatsapp-fill text-base sm:text-lg flex-shrink-0"></i>
                  <span>WHATSAPP</span>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Factores de Coste */}
        <section className="bg-white py-16 sm:py-20 overflow-hidden">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center text-gray-900 mb-6">
              ¿Cuánto cuesta vaciar un piso?
            </h2>
            <p className="text-center text-sm sm:text-base text-gray-700 max-w-3xl mx-auto mb-12 sm:mb-16 px-4">
              El coste depende de varios factores. Te damos un presupuesto claro tras la evaluación. <a href="/faq" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">Consulta nuestras preguntas frecuentes</a> para más información.
            </p>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
              {[
                { icon: 'ri-ruler-line', title: 'Superficie y volumen', desc: 'Metros cuadrados y cantidad de objetos' },
                { icon: 'ri-stairs-line', title: 'Accesos y ascensor', desc: 'Disponibilidad de ascensor o escaleras' },
                { icon: 'ri-tools-line', title: 'Desmontajes necesarios', desc: 'Muebles que requieren desmontaje' },
                { icon: 'ri-time-line', title: 'Urgencia del servicio', desc: 'Plazos y disponibilidad requerida' },
                { icon: 'ri-delete-bin-line', title: 'Tipo de residuos', desc: 'Gestión especial de ciertos materiales' },
                { icon: 'ri-price-tag-3-line', title: 'Valor de los objetos', desc: 'Muebles y enseres con valor de reventa' },
              ].map((item, index) => (
                <div key={index} className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                  <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-full mb-4">
                    <i className={`${item.icon} text-teal-600 text-2xl`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                  <p className="text-gray-600 text-sm">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="relative py-24 sm:py-32 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Happy%20satisfied%20client%20shaking%20hands%20with%20professional%20clearance%20team%20member%20in%20empty%20bright%20Barcelona%20apartment%2C%20successful%20service%20completion%2C%20friendly%20professional%20interaction%2C%20warm%20natural%20lighting%2C%20trust%20and%20satisfaction%2C%20professional%20service%20handshake%20in%20clean%20vacant%20home&width=1920&height=1080&seq=handshake-cta-001&orientation=landscape"
              alt="Contacta con nosotros"
              className="w-full h-full object-cover object-top"
              loading="lazy"
              decoding="async"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
          </div>

          <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-serif font-bold text-white mb-6 uppercase">
              ¿LISTO PARA VACIAR TU PISO?
            </h2>
            <p className="text-lg sm:text-xl text-white/90 mb-8 sm:mb-12">
              Evaluación gratuita en 24-48 horas / Sin compromiso
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mb-6 sm:mb-8">
              <a
                href="tel:+34936940041"
                className="flex items-center space-x-2 sm:space-x-3 px-6 sm:px-8 py-3 sm:py-4 bg-teal-600 text-white rounded-full text-sm sm:text-base font-medium hover:bg-teal-700 transition-all hover:scale-105 whitespace-nowrap cursor-pointer w-full sm:w-auto justify-center"
              >
                <i className="ri-phone-fill text-lg sm:text-xl flex-shrink-0"></i>
                <span>LLAMAR 936 94 00 41</span>
              </a>
              <a
                href="https://wa.me/34633759649"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 sm:space-x-3 px-6 sm:px-8 py-3 sm:py-4 bg-green-600 text-white rounded-full text-sm sm:text-base font-medium hover:bg-green-700 transition-all hover:scale-105 whitespace-nowrap cursor-pointer w-full sm:w-auto justify-center"
              >
                <i className="ri-whatsapp-fill text-lg sm:text-xl flex-shrink-0"></i>
                <span>WHATSAPP 633 759 649</span>
              </a>
              <a
                href="/contacto"
                className="flex items-center space-x-2 sm:space-x-3 px-6 sm:px-8 py-3 sm:py-4 bg-white text-gray-900 rounded-full text-sm sm:text-base font-medium hover:bg-gray-100 transition-all hover:scale-105 whitespace-nowrap cursor-pointer w-full sm:w-auto justify-center"
              >
                <i className="ri-mail-line text-lg sm:text-xl flex-shrink-0"></i>
                <span>FORMULARIO</span>
              </a>
            </div>

            <p className="text-xs sm:text-sm text-white/80">
              O escríbenos a vaciadosmarius@gmail.com
            </p>
          </div>
        </section>
      </main>
    </>
  );
}
